/**
 * 主題註冊中心
 * 
 * 這個檔案管理所有可用的計時器主題
 * 要新增主題，只需：
 * 1. 在 themes 資料夾下創建新的主題資料夾
 * 2. 實現主題的 index.tsx
 * 3. 在下面的 themes 物件中註冊
 */

import { TimerTheme } from './types'
import NormalTheme from './normal'
import ChristmasTheme from './christmas'

/**
 * 所有註冊的主題
 * 
 * 新增主題範例：
 * import NewYearTheme from './newyear'
 * 
 * export const themes = {
 *   normal: NormalTheme,
 *   christmas: ChristmasTheme,
 *   newyear: NewYearTheme,  // 新增這行
 * } as const
 */
export const themes = {
  normal: NormalTheme,
  christmas: ChristmasTheme,
} as const

/**
 * 主題鍵值類型
 */
export type ThemeKey = keyof typeof themes

/**
 * 獲取主題
 * @param key 主題名稱
 * @returns 主題物件，如果不存在則返回 normal 主題
 */
export const getTheme = (key: string): TimerTheme => {
  const themeKey = key as ThemeKey
  return themes[themeKey] || themes.normal
}

/**
 * 獲取所有可用的主題列表
 * @returns 主題列表
 */
export const getAvailableThemes = (): Array<{ key: ThemeKey; theme: TimerTheme }> => {
  return Object.entries(themes).map(([key, theme]) => ({
    key: key as ThemeKey,
    theme,
  }))
}

/**
 * 檢查主題是否存在
 * @param key 主題名稱
 * @returns 是否存在
 */
export const themeExists = (key: string): boolean => {
  return key in themes
}

// 導出類型
export * from './types'
